import reducerRegistry from '@comeon/reducer-registry';
import { LOGOUT } from '@comeon/actions-public';

import REDUCER_NAME from './reducer-name';
import * as AN from './actions';
import preloadedState from './preloaded-state';

function reducer(state = preloadedState, { type, payload }) {
	switch (type) {
		case AN.CLEAR_BANKID:
		case LOGOUT:
			return preloadedState;
		case AN.BANKID_COMPLETE:
		case AN.BANKID_AUTH_FAILED:
			return {
				...state,
				initiatePolling: false,
				loading: false
			};
		case AN.BANKID_SHOW_COMPLIANCE:
			return {
				...state,
				showCompliance: true
			};
		case AN.BANKID_TOKEN_RECEIVED:
			return {
				...state,
				...payload
			};
		case AN.INITIATE_BANKID:
			return {
				...state,
				initiatePolling: true
			};
		case AN.BANKID_EXTRA_INFO_PROMPT:
			return {
				...state,
				extraInfoPrompt: payload
			};
		case AN.BANKID_ACCOUNT_LINK_PROMPT:
			return {
				...state,
				accountLink: payload
			};
		case AN.BANKID_SESSION_CRITERIA:
			return {
				...state,
				sessionCriteria: payload
			};
		case AN.BANKID_UPDATE_ORDER_REF:
			return {
				...state,
				orderRef: payload
			};
		case AN.SWISH_INSTALLED_ON_MOBILE:
			return {
				...state,
				isSwishInstalledOnMobile: payload
			};
		case AN.BANKID_LOADING: {
			return {
				...state,
				loading: payload
			};
		}
		default:
			return state;
	}
}

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
